import { observable, action } from 'mobx';
import { ContentApiSdk, INodeTemplate, INodeTemplateError } from '~api/ContentApiSdk';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/ContentService';
import { Node, INodeContent } from '~domain/entities/Node';

export class ContentRepository {
    private contentApiSdk: ContentApiSdk;
    @observable private _nodes: Map<number, INodeContent>;

    constructor() {
        this.contentApiSdk = diContainer.get(serviceNames.contentApiSdk);
        this._nodes = new Map();
    }

    @action
    public loadContentData = async (nid: number): Promise<void | null> => {
        const cached = this.getContent(nid);
        if (cached) {
            return;
        }

        const apiResponse = await this.contentApiSdk.getContent(nid);

        if (nid in apiResponse) {
            const templateFields = (<INodeTemplate>apiResponse)[nid].template_fields || {
                layout: '',
                data: []
            };

            const templateNodes = Array.isArray(templateFields) ? templateFields : [templateFields];

            const { layout } = <INodeContent>templateNodes[0];
            const data = templateNodes.map((item) => item.data);

            this.setContent({
                nid,
                layout,
                data
            });

            const error = (<INodeTemplateError>apiResponse)[nid].error;

            if (error) {
                throw new Error(`code error: ${error.code}, message: ${error.message}`);
            }
        }
    };

    @action
    public setContent(content: INodeContent): void {
        const { nid } = content;
        this._nodes.set(nid, Node.fromJson(content));
    }

    public getContent(nid: number): INodeContent | undefined {
        return <INodeContent | undefined>this._nodes.get(nid);
    }

    get nodes() {
        return this._nodes;
    }
}
